import { DISCOVERY_SECTIONS, type DiscoveryScreenCard } from '~/ui-apps/screener-app/screenerDiscovery.data';
import type { CatalogOption } from './mockOnboardingCatalog';

const popularSearchesSection = DISCOVERY_SECTIONS.find((section) => section.id === 'popular-searches');

export const POPULAR_SEARCH_CARDS: DiscoveryScreenCard[] = popularSearchesSection?.cards ?? [];

export const POPULAR_SEARCH_OPTIONS: CatalogOption[] = POPULAR_SEARCH_CARDS.map((card) => ({
  id: card.id,
  label:
    card.id === 'high-growth-profitable' ? 'Growth and Profitable' : card.title,
}));

export const ALL_POPULAR_SEARCH_IDS = POPULAR_SEARCH_OPTIONS.map((option) => option.id);

export const POPULAR_SEARCH_TITLES = new Set(POPULAR_SEARCH_CARDS.map((card) => card.title));

export function getPopularSearchCard(searchId: string): DiscoveryScreenCard | undefined {
  return POPULAR_SEARCH_CARDS.find((card) => card.id === searchId);
}

export function getPopularSearchIdByTitle(title: string): string | undefined {
  const normalized = title.trim();
  if (!normalized) {
    return undefined;
  }

  return POPULAR_SEARCH_CARDS.find((card) => card.title === normalized)?.id;
}

export function hasPopularSearchQuery(searchId: string): boolean {
  const query = getPopularSearchCard(searchId)?.query?.trim() ?? '';
  return query.length > 0;
}
